module.exports = __webpack_public_path__ + "img/call-chat.657fd82.webp";